import { Component, OnDestroy, OnInit, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { GlobalNavComponent } from './shared/components/global-nav/global-nav.component';
import { SecondaryNavComponent } from './shared/components/secondary-nav/secondary-nav.component';
import { AppFooterComponent } from './shared/components/app-footer/app-footer.component';
import { IdleTimeoutService } from './core/services/idle-timeout.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, GlobalNavComponent, SecondaryNavComponent, AppFooterComponent],
  templateUrl: './app.html',
  styleUrls: ['./app.scss']
})
export class App implements OnInit, OnDestroy {
  private readonly idleTimeoutService = inject(IdleTimeoutService);

  readonly idleWarningVisible = this.idleTimeoutService.warningVisible;
  readonly countdownText = computed(() => {
    const totalSeconds = this.idleTimeoutService.countdownSeconds();
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  });

  ngOnInit(): void {
    this.idleTimeoutService.start();
  }

  ngOnDestroy(): void {
    this.idleTimeoutService.stop();
  }

  continueSession(): void {
    this.idleTimeoutService.continueSession();
  }

  logoutNow(): void {
    this.idleTimeoutService.logoutNow();
  }
}
